import { connect } from 'react-redux'
import PatientIPRWishesWidget from './PatientIPRWishesWidget'
import { isIPRProviderStore } from '../../../globals/state/selector'
import { selectCustomer } from '../../../customer/state/detail/selector'
import * as action from '../../../anamnesis/state/anamnesis/action'
import {selectMedicalAssessment, selectIsFetching} from "../../../anamnesis/state/anamnesis/selector";
import {selectLastMedicalAssessment} from "../../../anamnesis/state/list/selector";
import {selectIsTaskReadOnly} from "../../state/task-detail/selector";

const mapStateToProps = (state, props) => {
    const customer = selectCustomer(state)
    let anamnesis = selectLastMedicalAssessment(state)
    if (props.taskName === 'medical_assessment') {
        anamnesis = selectMedicalAssessment(state);
    }

    return {
        anamnesis: anamnesis,
        readOnly: selectIsTaskReadOnly(state),
        fetching: selectIsFetching(state),
        isIPRProviderStore: isIPRProviderStore(state, customer.store),
        taskName: props.taskName || '',
    }
}

const mapDispatchToProps = {
    changeAnamnesis: action.changeAnamnesis,
    saveAnamnesis: action.saveAnamnesis,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientIPRWishesWidget)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/PatientIPRWishesWidgetContainer.js